// src/components/Footer.jsx
export default function Footer() {
  const ig = [
    { src: "/images/IG-1.jpg", url: "https://instagram.com/" },
    { src: "/images/IG-2.jpg", url: "https://instagram.com/" },
    { src: "/images/IG-3.jpg", url: "https://instagram.com/" },
    { src: "/images/IG-4.jpg", url: "https://instagram.com/" },
  ];

  return (
    <footer className="bg-[#03344F] text-white">
      <div
        className="mx-auto max-w-6xl px-6 py-10 grid gap-8 md:grid-cols-[1fr,2fr]"
        style={{ fontFamily: "Montserrat, ui-sans-serif, system-ui" }}
      >
        {/* Columna izquierda */}
        <div>
          <h3 className="text-lg md:text-xl font-semibold">Beauty Care</h3>
          <p className="mt-3 text-white/80 leading-relaxed max-w-sm">
            Do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
            minim veniam, quis nostrud exercitation ullamco laboris.
          </p>

          <p className="mt-6 font-semibold">Follow Us</p>
        </div>

        {/* Columna derecha */}
        <div>
          <h3 className="text-lg md:text-xl font-semibold">Instagram Shop</h3>

          <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {ig.map(({ src, url }, i) => (
              <a
                key={i}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="block overflow-hidden rounded-md bg-white/5 ring-1 ring-white/10
                           hover:scale-[1.02] transition"
                aria-label={`Open Instagram post ${i + 1}`}
              >
                <img
                  src={src}
                  alt={`Instagram post ${i + 1}`}
                  loading="lazy"
                  className="w-full h-28 sm:h-32 object-cover"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
